module.exports = __webpack_public_path__ + "static/media/11-15.6ad38f40.mp3";